var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{attrs:{"dark":"","items":_vm.crumbs}})
}
var staticRenderFns = []

export { render, staticRenderFns }